// istanbul ignore file
import { Box, Button, Grid, Typography, Dialog, DialogActions, DialogTitle, Divider, Drawer } from '@mui/material'
import React, { useCallback, useEffect } from 'react'
import './assetDashboard.css'
import DarkUnica from 'highcharts/themes/dark-unica'
import * as HighCharts from 'highcharts'
import LanguageStrings from '../../../i18n/locales'
import { MemoFlameFlowGraph } from '../components/FlameSignalGraph'
import { MemoFuelFlowGraph } from '../components/FuelFlowGraph'
import NestedMenuWithCheckboxes from './deviceStatusCard'

import notificationIcon from '../../../assets/Notification-Icon.png'
import AlertNotification from './alertNotification'
import { type ConnectedProps, connect } from 'react-redux'
import { type RootState } from '../../../store'
import { getSaveDeafaultWidget, getHealthSummaryService, getAlertsNotificationDataByFilter } from '../../device-dashboard/redux/actionCreator'
import { getHealthScoreAssetservice, getHeaderSummaryRegisterAssetDashboardService, getHeaderSummaryKPIAssetDashboardService, getAlertCountDashboardService, getAssetPerformanceKPIDataDashboardService, getAssetPerformanceDataDashboardService, getAlertTrendKPIDataDashboardService, getAlertTrendRegisterDataDashboardService, fetchParameterTree } from '../redux/actionCreator'
import { useLocation } from 'react-router-dom'
import { MemoHealthSummaryCard } from '../../device-dashboard/components/healthSummaryCard'
import dayjs from 'dayjs'
import { MemoAssetHeaderSummary } from './AssetHeaderSummary'
import { MemoPerformance } from './Performance'
import { MemoAssetAlertDuration } from './AlertDuration'
import { MemoAssetAlertTrend } from './AssetAlertTrend'
import { DEFAULT_DATA_PERFORMANCE_WINDOW_HOURS, DEFAULT_DATA_WINDOW_HOURS } from '../../../utils/DashboardContants'

const AssetDashboardStrings = LanguageStrings().AssetDashboardStrings

const summary = (props: AllProps): JSX.Element => {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const [openFilter, setOpenFilter] = React.useState(false)
  const range = { selectedTime: 'hourly', timezone: userTimezone, status: props.customeSelection ? 'Custom range' : 'Go live' }
  const [isModalAlertTrend, setIsModalAlertTrend] = React.useState(false)
  const [isModalOpen, setIsModalOpen] = React.useState(false)
  const [isModalOpenPerformance, setIsModalOpenPerformance] = React.useState(false)
  const [applyButton, setApplyButton] = React.useState(false)
  const [isdefault, setisdefault] = React.useState(true)
  const dashboardHours = DEFAULT_DATA_WINDOW_HOURS
  const performanceDefaultHours = DEFAULT_DATA_PERFORMANCE_WINDOW_HOURS

  const stateLocation = useLocation()
  interface StateLocation {
    parentSiteId: string
    parentAssetId: string
    siteName: string
    assetName: string
    deviceName: string
  }

  const navigateState = stateLocation.state as StateLocation | null
  const parentSiteId = (navigateState != null) ? navigateState.parentSiteId : ''
  const parentAssetId = (navigateState != null) ? navigateState.parentAssetId : ''
  const parentAssetName = (navigateState != null) ? navigateState.assetName : ''

  useEffect(() => {
    props?.fetchParameterTree()
  }, [])

  const defaultParam = JSON.stringify({
    assetId: parentAssetId,
    devices: []
  })

  const defaultParamKPI = JSON.stringify({
    assetId: parentAssetId,
    devices: [],
    assets: []
  })

  const getUtcDateRange = (): { today: string, defaultDataWindowUTC: string, defaultPerformanceDataWindowUTC: string } => {
    const utcDate = dayjs()
    const today = utcDate.utc().format('YYYY-MM-DD HH:mm:ss')
    const defaultDataWindowUTC = utcDate.utc().subtract(dashboardHours, 'hour').format('YYYY-MM-DD HH:mm:ss')
    const defaultPerformanceDataWindowUTC = utcDate.utc().subtract(performanceDefaultHours, 'hour').format('YYYY-MM-DD HH:mm:ss')
    return { today, defaultDataWindowUTC, defaultPerformanceDataWindowUTC }
  }

  const handleSetIsModalOpen = useCallback(() => {
    setIsModalOpen(true)
  }, [])

  const handleOpenModalAssetPerformance = useCallback(() => {
    setIsModalOpenPerformance(true)
  }, [])

  const handleOpenModalAlertTrend = useCallback(() => {
    setIsModalAlertTrend(true)
  }, [])

  const handleCloseModal = (): void => {
    setIsModalOpen(false)
    setIsModalOpenPerformance(false)
    setIsModalAlertTrend(false)
  }

  interface StateLocation {
    parentSiteId: string
    parentAssetId: string
  }

  React.useEffect(() => {
    if (parentSiteId !== '' && parentAssetId !== '' && props.IsGolive) {
      const { today, defaultDataWindowUTC, defaultPerformanceDataWindowUTC } = getUtcDateRange()
      const startDate = props.startDate !== '' && props.endDate !== '' ? props.startDate : defaultDataWindowUTC
      const endDate = props.startDate !== '' && props.endDate !== '' ? props.endDate : today
      // Fetching Asset Status Data
      props.getHeaderSummaryRegisterAssetDashboardService(parentSiteId, parentAssetId, 'assetStatus', null, true)
      props.getHeaderSummaryKPIAssetDashboardService(parentSiteId, parentAssetId, 'assetStatus', null, true)

      // Fetching Asset HealthScore Data
      props.getHealthScoreAssetservice(parentSiteId, parentAssetId)

      // Fetching HealthSummary
      props.callGetHealthSummaryService(parentSiteId, parentAssetId, ' ')

      // Fetching Alert Trend
      props.getAlertTrendKPIDataDashboardService(startDate, endDate, 'assetAlertTrend', defaultParamKPI, `${range.selectedTime},${range.timezone},${range.status}`, true)
      props.getAlertTrendRegisterDataDashboardService(startDate, endDate, 'assetAlertTrend', defaultParam, `${range.selectedTime},${range.timezone},${range.status}`, true)

      // Fetching AlertCount
      props.getAlertCountDashboardService(parentSiteId, parentAssetId, '')

      // Fetching Asset Performance Data
      props.getAssetPerformanceDataDashboardService(defaultPerformanceDataWindowUTC, today, 'assetPerformance', defaultParam, true)
      props.getAssetPerformanceKPIDataDashboardService(defaultPerformanceDataWindowUTC, today, 'assetPerformance', defaultParamKPI, true)
      props.getSaveDeafaultWidget(parentSiteId, parentAssetId, parentAssetId)
    }
  }, [props.Golive, parentAssetId, parentSiteId])

  const handleIconClick = (): void => {
    setOpenFilter(true)
    props.callGetHealthSummaryService(parentSiteId, parentAssetId, ' ')
    props.getAlertsNotificationDataByFilter(parentSiteId, parentAssetId, '', '', '', '', 'desc')
  }

  React.useEffect(() => {
    setIsModalOpen(false)
    setIsModalOpenPerformance(false)
    setIsModalAlertTrend(false)
    if (applyButton) {
      setApplyButton(false)
    }
  }, [applyButton])

  const handleApplyButton = (): void => {
    setApplyButton(true)
    setisdefault(false)
  }

  const dialogParameterSelection = (open: boolean, graphName: string): JSX.Element => {
    return (
        <Dialog open={open} onClose={handleCloseModal} maxWidth="md" fullWidth
                  sx={{
                    '& .MuiDialog-paper': {
                      width: '440px',
                      height: '550px',
                      backgroundColor: '#252525', // Set your desired background color
                      color: '#f0f0f0'
                    }
                  }}
                  >
              <DialogTitle>Parameter Library</DialogTitle>
                 <NestedMenuWithCheckboxes
                  currentSiteID={parentSiteId}
                  CurrentAssetID={parentAssetId}
                  graphName={graphName}
                  applyButton={applyButton}
                  isdefault={isdefault}
                  startDate={props.startDate}
                  endDate={props.endDate}
                  range={range}
                />
              <Divider sx={{ backgroundColor: '#272727', border: '3px solid #272727', margin: '10px 0px' }} />
              <DialogActions sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button onClick={handleCloseModal} color="primary">
                  Close
                </Button>
                <Button className="apply-btn" style={{ backgroundColor: '#64C3FF', color: '#303030', fontWeight: 'bold' }} onClick={handleApplyButton} color="primary">
                  Apply
                </Button>
              </DialogActions>
            </Dialog>
    )
  }

  DarkUnica(HighCharts)
  return (
    <>
    <div className='main-dashboard'>
    <div className="summary">
      <MemoAssetHeaderSummary
        parentSiteId= {parentSiteId}
        parentAssetId = {parentAssetId}
        parentAssetName = {parentAssetName}
        saveDefaultView = {props.saveDefaultView}
        isModalOpen = {isModalOpen}
        setIsModalOpen = {handleSetIsModalOpen}
        dialogParameterSelection = {dialogParameterSelection}
        />
    </div>
    <div>
    <Grid container spacing={2} sx={{ height: '100%', marginTop: '20px' }}>
  {/* First Column (4 spaces) */}
  <Grid item xs={3.5} sx={{ display: 'flex', flexDirection: 'column' }}>
    <Box
      sx={{
        backgroundColor: '#252525',
        padding: '15px 20px',
        borderRadius: '8px',
        flex: 1
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
        <Typography className='title-box'>{AssetDashboardStrings.healthSummary}</Typography>
        <Typography style={{ color: '#f0f0f0' }}><span><img onClick={handleIconClick} style={{ width: '38px', height: '38px', cursor: 'pointer', color: '#fff' }} src={notificationIcon}></img></span></Typography>
      </div>
      <div className="inner-wrapper" style={{ marginTop: '3rem' }} data-testid="healthSummaryCard">
        <MemoHealthSummaryCard currentDeviceId={parentAssetId} />
      </div>
    </Box>
  </Grid>

  {/* Second Column (4 spaces) */}
  <Grid item xs={4.5} sx={{ display: 'flex', flexDirection: 'column', position: 'relative' }}>
      <MemoAssetAlertTrend
        parentAssetId={parentAssetId}
        startDate={props.startDate}
        endDate={props.endDate}
        customeSelection={props.customeSelection}
        isModalAlertTrend={isModalAlertTrend}
        setIsOpenModalAlertTrend={handleOpenModalAlertTrend}
        dialogParameterSelection={dialogParameterSelection}
        Golive={props.Golive}
        tabSwitch={props.tabSwitch} />
  </Grid>

  {/* Third Column (4 spaces) */}
  <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column' }}>
    <MemoAssetAlertDuration parentSiteId={parentSiteId} parentAssetId={parentAssetId} Golive ={props.Golive} startDate={props.startDate} endDate={props.endDate} tabSwitch={props.tabSwitch} />
  </Grid>
</Grid>
    <Grid container spacing={2} marginTop={'10px'}>
    <Grid item xs={3}>
        <MemoPerformance
          isModalOpenPerformance = {isModalOpenPerformance}
          setIsModalOpenPerformance = {handleOpenModalAssetPerformance}
          dialogParameterSelection = {dialogParameterSelection} />
    </Grid>
    <Grid style={{ marginTop: '-20px' }} item xs={9}>
    <Grid container style={{ marginTop: '20px' }}>
        <Grid item xs={12} sm={12}>
          <MemoFlameFlowGraph
            deviceIdCurrent={''}
            assetTypeID={''}
            startDate={props.startDate}
            endDate={props.endDate}
            Golive={props.Golive}
            IsGolive={props.IsGolive}
            stopInterval={props.stopInterval}
            startInterval={props.startInterval}
            parentAssetId={parentAssetId}
            parentSiteId={parentSiteId}
            />
        </Grid>
      </Grid>
      <Grid container style={{ marginTop: '20px', marginBottom: '20px' }}>
        <Grid item xs={12} sm={12}>
          <MemoFuelFlowGraph
            deviceIdCurrent={''}
            assetTypeID={''}
            startDate={props.startDate}
            endDate={props.endDate}
            Golive={props.Golive}
            IsGolive={props.IsGolive}
            stopInterval={props.stopInterval}
            startInterval={props.startInterval}
            parentAssetId={parentAssetId}
            parentSiteId={parentSiteId}
            />
        </Grid>
      </Grid>
    </Grid>
    </Grid>
    </div>
    <Drawer
        anchor='right'
        open={openFilter}
        className='filter-drawer device-dashboard'
          onClose={() => { setOpenFilter(false) }}
    >
      <AlertNotification siteId={parentSiteId} assetId={parentAssetId} deviceId={''} setOpenFilter={setOpenFilter} />
    </Drawer>
   </div>
   </>
  )
}

interface DispatchToProps {
  fetchParameterTree: () => void
  callGetHealthSummaryService: (siteId: string, asseIds: string, deviceIds: string) => void
  getSaveDeafaultWidget: (siteId: string, parentAssetId: string, deviceIds: string) => void
  getAlertsNotificationDataByFilter: (siteId: string, assetIds: string, deviceIds: string, severities: string, alertStatus: string, alarmLabelIds: string, sortOrder: string) => void
  getHealthScoreAssetservice: (siteId: string, deviceId: string) => void
  getAlertCountDashboardService: (siteId: string, assetId: string, severity: string) => void
  getAlertTrendKPIDataDashboardService: (startDate: string, endDate: string, graphName: string, requestParameter: string, intervalGroup: string, isdefault: boolean) => void
  getAlertTrendRegisterDataDashboardService: (startDate: string, endDate: string, graphName: string, requestParameter: string, intervalGroup: string, isdefault: boolean) => void
  getAssetPerformanceDataDashboardService: (startDate: string, endDate: string, graphName: string, requestParams: any, isdefault: boolean) => void
  getAssetPerformanceKPIDataDashboardService: (startDate: string, endDate: string, graphName: string, requestParams: any, isdefault: boolean) => void
  getHeaderSummaryRegisterAssetDashboardService: (siteId: string, assetId: string, graphName: string, requestParams: any, isdefault: boolean) => void
  getHeaderSummaryKPIAssetDashboardService: (siteId: string, assetId: string, graphName: string, requestParams: any, isdefault: boolean) => void
}

const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  fetchParameterTree: () => dispatch(fetchParameterTree()),
  callGetHealthSummaryService: (siteId: string, asseIds: string, deviceIds: string) => dispatch(getHealthSummaryService(siteId, asseIds, deviceIds)),
  getSaveDeafaultWidget: (siteId: string, parentAssetId: string, deviceIds: string) => dispatch(getSaveDeafaultWidget(siteId, parentAssetId, deviceIds)),
  getAlertsNotificationDataByFilter: (siteId: string, assetIds: string, deviceIds: string, severities: string, alertStatus: string, alarmLabelIds: string, sortOrder: string) => dispatch(getAlertsNotificationDataByFilter(siteId, assetIds, deviceIds, severities, alertStatus, alarmLabelIds, sortOrder)),
  getHealthScoreAssetservice: (siteId: string, deviceId: string) => dispatch(getHealthScoreAssetservice(siteId, deviceId)),
  getAlertCountDashboardService: (siteId: string, assetId: string, severity: string) => dispatch(getAlertCountDashboardService(siteId, assetId, severity)),
  getAlertTrendKPIDataDashboardService: (startDate: string, endDate: string, graphName: string, requestParameter: string, intervalGroup: string, isdefault: boolean) => dispatch(getAlertTrendKPIDataDashboardService(startDate, endDate, graphName, requestParameter, intervalGroup, isdefault)),
  getAlertTrendRegisterDataDashboardService: (startDate: string, endDate: string, graphName: string, requestParameter: string, intervalGroup: string, isdefault: boolean) => dispatch(getAlertTrendRegisterDataDashboardService(startDate, endDate, graphName, requestParameter, intervalGroup, isdefault)),
  getAssetPerformanceDataDashboardService: (startDate: string, endDate: string, graphName: string, requestParams: any, isdefault: boolean) => dispatch(getAssetPerformanceDataDashboardService(startDate, endDate, graphName, requestParams, isdefault)),
  getAssetPerformanceKPIDataDashboardService: (startDate: string, endDate: string, graphName: string, requestParams: any, isdefault: boolean) => dispatch(getAssetPerformanceKPIDataDashboardService(startDate, endDate, graphName, requestParams, isdefault)),
  getHeaderSummaryRegisterAssetDashboardService: (siteId: string, assetId: string, graphName: string, requestParams: any, isdefault: boolean) => dispatch(getHeaderSummaryRegisterAssetDashboardService(siteId, assetId, graphName, requestParams, isdefault)),
  getHeaderSummaryKPIAssetDashboardService: (siteId: string, assetId: string, graphName: string, requestParams: any, isdefault: boolean) => dispatch(getHeaderSummaryKPIAssetDashboardService(siteId, assetId, graphName, requestParams, isdefault))
})

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface StateToProps {
}

const mapStateToProps = (state: RootState): StateToProps => ({
})

const connector = connect(mapStateToProps, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>

interface currentDeviceID {
  startDate: string
  endDate: string
  Golive: boolean
  IsGolive: boolean
  saveDefaultView: boolean
  customeDateSelection: boolean
  customeSelection: boolean
  stopInterval: any
  startInterval: any
  tabSwitch?: any
}

type AllProps = PropsFromRedux & currentDeviceID

export const MemoSummary = React.memo(connector(summary))
